import { StatisticsSearchCriteria } from "@app/core/statistics/domain/statistics-search-criteria";
import { dateToString } from "@app/presentation/utils/text.utils";

export class StatisticsSearchCriteriaMapper {
  static serialize(criteria: StatisticsSearchCriteria) {
    return {
      //If the value is null, the property is not added to the object
      ...(criteria.startDate
        ? { start_date: dateToString(criteria.startDate) }
        : {}),
      //If the value is null, the property is not added to the object
      ...(criteria.endDate ? { end_date: dateToString(criteria.endDate) } : {}),
      //If the value is null, the property is not added to the object
      ...(criteria.limit ? { limit: criteria.limit } : {}),
    };
  }
}
